import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import useStyles from './../styles';
import { useFormik } from 'formik';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { toast } from '@livable/saas-react-components';
import { TextField, Button } from '@mui/material';
import { BackdropLoader } from '@livable/saas-react-components';
import { AddNewAppfolioSchema } from 'src/utils/formValidation/Appfolio';
import { DetailedStreetFinder } from 'src/components/general/DetailedStreetFinder';
export const EditModalForm = observer(_ref => {
  var _store$address, _store$address2;
  let data = _ref.data,
    callback = _ref.callback,
    addressData = _ref.addressData,
    handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    handleStartValidate = _useState4[0],
    setHandleStartValidate = _useState4[1];
  const _useState5 = useState({
      name: '',
      clientId: '',
      ownerEmail: '',
      companyName: '',
      clientSecret: '',
      ownerLastName: '',
      ownerFirstName: '',
      postalAddress: ''
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    formikInitialValues = _useState6[0],
    setFormikInitialValues = _useState6[1];
  const _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    formikInitialValuesSaved = _useState8[0],
    setFormikInitialValuesSaved = _useState8[1];
  const formik = useFormik({
    initialValues: formikInitialValues,
    validationSchema: AddNewAppfolioSchema,
    enableReinitialize: true,
    validateOnMount: true,
    onSubmit: async () => {
      setIsLoading(true);
      setHandleStartValidate(true);
    }
  });
  const handleStartSubmitting = async _addressId => {
    try {
      const cData = {
        credentialsId: data.id,
        requestData: {}
      };
      if (formik.values.name !== formikInitialValuesSaved.name) cData.requestData.name = {
        value: formik.values.name
      };
      if (formik.values.companyName !== formikInitialValuesSaved.companyName) cData.requestData.companyName = {
        value: formik.values.companyName
      };
      if (formik.values.clientId !== formikInitialValuesSaved.clientId) cData.requestData.clientId = {
        value: formik.values.clientId
      };
      if (formik.values.ownerEmail !== formikInitialValuesSaved.ownerEmail) cData.requestData.ownerEmail = {
        value: formik.values.ownerEmail
      };
      if (formik.values.clientSecret !== formikInitialValuesSaved.clientSecret) cData.requestData.clientSecret = {
        value: formik.values.clientSecret
      };
      if (formik.values.ownerFirstName !== formikInitialValuesSaved.ownerFirstName) cData.requestData.ownerFirstName = {
        value: formik.values.ownerFirstName
      };
      if (formik.values.ownerLastName !== formikInitialValuesSaved.ownerLastName) cData.requestData.ownerLastName = {
        value: formik.values.ownerLastName
      };
      if (_addressId) cData.requestData.addressId = {
        value: _addressId
      };
      const resp = await store.credentials.patchCredentialsAsync.run(cData);
      if (resp && resp.isSuccessful) {
        toast('success', {
          body: ['Successfully saved']
        });
        await callback();
        handleModalClose();
      }
    } finally {
      setIsLoading(false);
    }
  };
  const handleEndSubmitting = async () => {
    setIsLoading(false);
  };
  useEffect(() => {
    setFormikInitialValues({
      name: data.name,
      clientId: data.clientId,
      ownerEmail: data.ownerEmail,
      companyName: data.companyName,
      clientSecret: data.clientSecret,
      ownerLastName: data.ownerLastName,
      ownerFirstName: data.ownerFirstName,
      postalAddress: addressData && addressData.street ? "".concat(addressData.street, " ").concat(addressData.city, ", ").concat(addressData.state, " ").concat(addressData.zip).concat(addressData.secondary ? ', ' + addressData.secondary : '') : ''
    });
    setFormikInitialValuesSaved({
      name: data.name,
      clientId: data.clientId,
      ownerEmail: data.ownerEmail,
      companyName: data.companyName,
      clientSecret: data.clientSecret,
      ownerLastName: data.ownerLastName,
      ownerFirstName: data.ownerFirstName
    });
    formik.setFieldTouched('name', true);
    formik.setFieldTouched('clientId', true);
    formik.setFieldTouched('ownerEmail', true);
    formik.setFieldTouched('companyName', true);
    formik.setFieldTouched('clientSecret', true);
    formik.setFieldTouched('ownerLastName', true);
    formik.setFieldTouched('ownerFirstName', true);
    formik.setFieldTouched('postalAddress', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Client Id'),
    variant: "outlined",
    fullWidth: true,
    id: "clientId",
    name: "clientId",
    value: formik.values.clientId,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.clientId && Boolean(formik.errors.clientId),
    helperText: formik.touched.clientId && t(formik.errors.clientId, t)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Client Secret'),
    variant: "outlined",
    fullWidth: true,
    id: "clientSecret",
    name: "clientSecret",
    value: formik.values.clientSecret,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.clientSecret && Boolean(formik.errors.clientSecret),
    helperText: formik.touched.clientSecret && t(formik.errors.clientSecret, t)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Credential Name'),
    variant: "outlined",
    fullWidth: true,
    id: "name",
    name: "name",
    value: formik.values.name,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.name && Boolean(formik.errors.name),
    helperText: formik.touched.name && t(formik.errors.name, t)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Company Name'),
    variant: "outlined",
    fullWidth: true,
    id: "companyName",
    name: "companyName",
    value: formik.values.companyName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.companyName && Boolean(formik.errors.companyName),
    helperText: formik.touched.companyName && t(formik.errors.companyName, t)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Livable Account Holder Email'),
    variant: "outlined",
    fullWidth: true,
    id: "ownerEmail",
    name: "ownerEmail",
    value: formik.values.ownerEmail,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.ownerEmail && Boolean(formik.errors.ownerEmail),
    helperText: formik.touched.ownerEmail && t(formik.errors.ownerEmail, t)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Livable Account Holder First Name'),
    variant: "outlined",
    fullWidth: true,
    id: "ownerFirstName",
    name: "ownerFirstName",
    value: formik.values.ownerFirstName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.ownerFirstName && Boolean(formik.errors.ownerFirstName),
    helperText: formik.touched.ownerFirstName && t(formik.errors.ownerFirstName, t)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('Livable Account Holder Last Name'),
    variant: "outlined",
    fullWidth: true,
    id: "ownerLastName",
    name: "ownerLastName",
    value: formik.values.ownerLastName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.ownerLastName && Boolean(formik.errors.ownerLastName),
    helperText: formik.touched.ownerLastName && t(formik.errors.ownerLastName, t)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.formWrapperItem
  }, /*#__PURE__*/React.createElement(DetailedStreetFinder, {
    name: "postalAddress",
    validator: formik,
    defaultPropertyAddress: addressData,
    disabled: isLoading || store.credentials.patchCredentialsAsync.inProgress,
    error: formik.touched.postalAddress && Boolean(formik.errors.postalAddress),
    helperText: formik.touched.postalAddress && formik.errors.postalAddress ? t(formik.errors.postalAddress, {
      field: t('company_details.corporate_postal_mailing_address')
    }) : undefined,
    _serviceVariableValidate: handleStartValidate,
    _serviceStopValidate: () => setHandleStartValidate(false),
    _serviceStartSubmitting: handleStartSubmitting,
    _serviceEndSubmitting: handleEndSubmitting
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: formik.handleSubmit,
    disabled: !formik.isValid || isLoading,
    variant: "priority",
    'custom-attribute': '521-appfolio-page'
  }, t('Save'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.credentials.getGlAccountsAsync.inProgress || store.credentials.getCredentialsAsync.inProgress || store.credentials.postCredentialsAsync.inProgress || store.credentials.patchCredentialsAsync.inProgress || store.credentials.deleteCredentialAsync.inProgress || store.credentials.getCredentialsUsersAsync.inProgress || store.credentials.getCredentialsPropertiesAsync.inProgress || store.credentials.patchCredentialsPropertiesAsync.inProgress || ((_store$address = store.address) === null || _store$address === void 0 || (_store$address = _store$address.addNewAddressAsync) === null || _store$address === void 0 ? void 0 : _store$address.inProgress) || ((_store$address2 = store.address) === null || _store$address2 === void 0 || (_store$address2 = _store$address2.updateAddressAsync) === null || _store$address2 === void 0 ? void 0 : _store$address2.inProgress)
  }));
});